import { observable, action, runInAction, toJS } from "mobx";
import { imgToPdf } from "imgtopdf";
import jsPDF from 'jspdf';
import moment from "moment";
import defaultRoomsData from "./Rooms/data";
import defaultFoodData from "./Food/data";
import compute from "./compute";
import { message, Modal } from "antd";
import getJson from "../../../method";

const { confirm } = Modal;

export const defaultDayData = [{
    name: "Grand Total<br/>总计",
    other_day: 0,
    other_last: 0,
    rev_day: 0,
    rev_last: 0,
}];

class Store {
    @observable print = false;
    @observable loading = false;
    @observable saveLoading = false;
    @observable roomData = [];
    @observable foodData = [];
    @observable dayData = [...defaultDayData];
    @observable date = moment().format('YYYY-MM-DD');

    @action
    getData = async (date) => {
        runInAction(() => {
            this.loading = true;
            this.roomData = [];
            this.foodData = [];
            this.dayData = [];
        });
        try {

            let roomData = JSON.parse(JSON.stringify(defaultRoomsData));
            let foodData = JSON.parse(JSON.stringify(defaultFoodData));
            let dayData = JSON.parse(JSON.stringify(defaultDayData));

            const url = `/_day_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}&day=${moment(date).format('D')}`;
            const json = await fetch(url, { credentials: 'include' })
            const res = await json.json();

            if (res.data.foodData && res.data.foodData.length > 0) {
                foodData = res.data.foodData.sort((a, b) => a.sort - b.sort);
            }
            if (res.data.roomData && res.data.roomData.length > 0) {
                roomData = res.data.roomData.sort((a, b) => a.sort - b.sort);
            }
            if (res.data.dayData) {
                dayData = [{ ...res.data.dayData }];
            }

            await this.onChange({ roomData, foodData, dayData });
            runInAction(() => {
                this.loading = false;
            })

        } catch (error) {
            runInAction(() => { this.loading = false });
            console.log(error);
        }
    }

    @action
    onChange = ({ roomData, foodData, dayData }) => {
        const data = compute({ roomData, foodData, dayData });
        this.roomData = data.roomData;
        this.foodData = data.foodData;
        this.dayData = data.dayData;
    }

    onSave = async () => {
        runInAction(() => { this.saveLoading = true });
        try {
            const date = this.date;
            const year = moment(date).format("YYYY");
            const month = moment(date).format("M");
            const day = moment(date).format("D");

            const roomData = this.roomData.map((x, i) => ({ ...x, year, month, day }));
            const foodData = this.foodData.map((x, i) => ({ ...x, year, month, day }));
            const dayData = this.dayData.map((x, i) => ({ ...x, year, month, day }));

            // 检查入住率是否合规，超过100% 禁止保存
            if (getJson([3, 'last'], roomData) > 1 || getJson([3, 'actual'], roomData) > 1) {
                confirm({
                    title: '出租率不能超100%，请检查无误后再保存!',
                    cancelText: "取消",
                    okText: "确定"
                });
                runInAction(() => { this.saveLoading = false });
                return
            }

            let dataFrom = new FormData();
            dataFrom.append('roomData', JSON.stringify(roomData));
            dataFrom.append('foodData', JSON.stringify(foodData));
            dataFrom.append('dayData', JSON.stringify(dayData));

            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }
            let json = await fetch('/add_day', headres);
            const res = await json.json();

            if (res.status == 1) {
                if (!dayData[0].id) this.getData(date);
                message.success('保存成功！');
            } else message.error(res.msg);

            runInAction(() => { this.saveLoading = false });

        } catch (error) {
            runInAction(() => { this.saveLoading = false });
            console.log(error);
        }
    }

    @action
    download = async () => {
        runInAction(() => { this.print = true });
        try {
            const res = await imgToPdf('daily', 1.5);
            let canvas = res.canvas;
            var pageData = canvas.toDataURL('image/png', 0.7);

            //方向默认横向，尺寸ponits, 按照图片大小进行输出
            var pdf = new jsPDF('l', 'pt', [canvas.width, canvas.height]);
            //需要dataUrl格式
            pdf.addImage(pageData, 'PNG', 0, 0, canvas.width, canvas.height);
            pdf.save(`Daily Revenue Report 每日经营报表.pdf`);
            runInAction(() => { this.print = false });
        } catch (error) {
            runInAction(() => { this.print = false });
            console.error(error);
        }
    }


}

const daily = new Store();

export default daily;


// WEBPACK FOOTER //
// ./src/components/table/daily/store.js